import moment from "moment"

export function isStringOnlyDigits(val) {
  return /^\d+$/.test(val)
}

export function sortByNumber(str1, str2) {
  return parseInt(str1.name, 10) - parseInt(str2.name, 10)
}

export function getOrderedMarkerData(data) {
  const orderedNumberArray = data.filter((item) => isStringOnlyDigits(item.name)).sort(sortByNumber)
  const nonNumericNamedArray = data.filter((item) => !isStringOnlyDigits(item.name)).sort(sortByNumber)
  return [...orderedNumberArray, ...nonNumericNamedArray]
}

export function dateAsString(dateAsMoment, withDashes) {
  const day = dateAsMoment.date()
  const dayAsString = day.toString()
  const dayStringOutput = day < 10 ? "0" + dayAsString : dayAsString

  const month = dateAsMoment.month()
  const actualMonthNum = month + 1
  const actualMonthNumAsString = actualMonthNum.toString()
  const monthStringOutput = actualMonthNum < 10 ? `0${actualMonthNumAsString}` : actualMonthNumAsString

  const yearAsString = dateAsMoment.year().toString()

  const dashString = withDashes ? "-" : ""

  return `${yearAsString}${dashString}${monthStringOutput}${dashString}${dayStringOutput}`
}

const campsiteOccupantTypeIds = {
  polmanter: { adults: 1096, children: 1097, infants: 1098 },
}

export function getMomentDateInFuture(date, amount, type = "days") {
  return date.add(amount, type)
}

export function getMomentDateInPast(date, amount, type = "days") {
  return date.subtract(amount, type)
}

export function openGemaparkBookingUrl(bookingDetails, unitId) {
  const {
    accomTypeId,
    campsiteName,
    endDate,
    gemaparkCompanyId,
    gemaparkParkId,
    numOfAdults,
    numOfChildren,
    numOfInfants,
    physicalUnitIdAtt,
    startDate,
  } = bookingDetails

  const startDateString = startDate ? dateAsString(moment(startDate), true) : dateAsString(moment(new Date()), true)
  const endDateString = startDate
    ? dateAsString(moment(endDate), true)
    : dateAsString(moment(endDate).add(4, "d"), true)

  const occupancyValues = `&oc=${numOfAdults ? `${campsiteOccupantTypeIds[campsiteName].adults}x${numOfAdults}m` : ""}${
    numOfChildren ? `-${campsiteOccupantTypeIds[campsiteName].children}x${numOfChildren}m` : ""
  }${numOfInfants ? `-${campsiteOccupantTypeIds[campsiteName].infants}x${numOfInfants}m` : ""}`

  const physicalUnitIdAttString = physicalUnitIdAtt ? `&ex=${physicalUnitIdAtt}` : ""

  const bookingPageUrl = `https://bookings.gemapark.co.uk/secure/Booking.aspx?cid=${gemaparkCompanyId}&pid=${gemaparkParkId}&utid=${unitId}&ad=${startDateString}&dd=${endDateString}${occupancyValues}&curid=1${physicalUnitIdAttString}&ct=${accomTypeId}`

  window.open(bookingPageUrl)
}

export function getMapIdFromName(name) {
  switch (name) {
    case "polmanter":
      return "54f4c01880110ec870407bad"
    case "swissfarm":
      return "5bc8140d8dbcba38beb55472"
    case "blaircastle":
      return "686e73c2c6496b002f4a8f7a"
    case "mountain-falls":
      return "687d6e9a7af64a002f4ed9de" // production
    // return "68c7943766e72562d98965de" // development
    case "tregarton":
      return "59a4be4dda784844b506e9cc"
    default:
      return name
  }
}
